// ErrorDialog.tsx
import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";
import { styled } from "@mui/material/styles";

interface ErrorDialogProps {
  open: boolean;
  content: any; 
  onClose: () => void;
}

const CenteredDialogContent = styled(DialogContent)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "left",
  minHeight: "100px", 
});

const ErrorDialog: React.FC<ErrorDialogProps> = ({ open, content, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle style={{ textAlign: "center" }}>Tips</DialogTitle>
      <CenteredDialogContent>
        {content}
      </CenteredDialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        <Button onClick={onClose} color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
